import { render, staticRenderFns } from "./RegistrationSingle.vue?vue&type=template&id=7e1a523a&scoped=true&"
import script from "./RegistrationSingle.vue?vue&type=script&setup=true&lang=ts&"
export * from "./RegistrationSingle.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./RegistrationSingle.vue?vue&type=style&index=0&id=7e1a523a&prod&scoped=true&lang=scss&"
import style1 from "./RegistrationSingle.vue?vue&type=style&index=1&id=7e1a523a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e1a523a",
  null
  
)

export default component.exports